export default {
  path: 'file_log',
  name: 'file_log',
  component: () => import(/* webpackChunkName: "file_log-list" */ '@/pages/file_log/FileLogList'),
  meta: { title: '文件日志' }
}
